import React, { Component } from 'react';
import check from '../../img/check.png'
import checkicon from '../../img/checkicon.png'
import finalizar from '../../img/Finalizar.png'
import firebase from 'firebase';
import Modal from 'react-modal';
import './modal.css';
import { withRouter } from "react-router-dom";
import Select from 'react-select';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        height: '350px',

    }
};

var options = {
    enableHighAccuracy: false,
    timeout: 5000,
    maximumAge: 0,
    isPoint: false,
    point: ''
};

const incidencias = [
    { value: 0, label: 'Accidente sobre carretera' },
    { value: 1, label: 'Bloqueo de calles' },
    { value: 2, label: 'Cantidad de personal en recogimiento arriba del promedio' },
    { value: 3, label: 'Fallas mecánicas en unidad' },
    { value: 4, label: 'Viaje finalizó en la Base (transbordo de personal a otro vehículo)' },
    { value: 5, label: 'Ruta en directo hacia el Aeropuerto por tráfico (1030)' },
    { value: 6, label: 'Se autorizó tiempo de espera adicional' },
    { value: 7, label: 'Se cambió hora de recogimiento' },
    { value: 8, label: 'Se agregó personal al recogimiento' },
    { value: 9, label: 'Tráfico antes de iniciar viaje' },
    { value: 10, label: 'Tráfico durante el recorrido' }
];

const btnAceptar = {
    content: {
        right: '300px',
    }
};

class BarraButtom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            coordE: {},
            comment: '',
            isActiveC: false,
            carretera: '',
            kmFinal: '',
            rapidin: false
        };
        this.showPosition = this.showPosition.bind(this);
    }

    componentDidMount() {
        navigator.geolocation.getCurrentPosition(this.showPosition, this.error, options);
    }

    error = (err) => {
        console.warn('ERROR(' + err.code + '): ' + err.message);
    };

    markStep = () => {
        let { userActu, userViaj, done } = this.props;
        firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).child('checkpoints').once('value').then(snap => {
            if (snap.val() === null)
                firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).child('checkpoints').set([{
                    timestamp: firebase.database.ServerValue.TIMESTAMP,
                    coordenadas: this.props.coords
                }]);
            else firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).child('checkpoints').set([
                ...snap.val(), {
                    timestamp: firebase.database.ServerValue.TIMESTAMP,
                    coordenadas: this.props.coords
                }]);
        });

        let puntoA = (userViaj.puntoA + 1)
        firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
            puntoA
        });
        done();
        this.setState({ isActiveC: false })

    }
    toggleModalG(index) {
        let active = 'isActive' + index;
        // if (this.state[active] === true) {
        //     this.finishViaje();
        // }
        this.setState({
            [active]: !this.state[active]
        })
    }

    toggleModalC = () => {
        if (this.state.isActiveC === true) {
            this.markStep();
        }
        this.setState({
            isActiveC: !this.state.isActiveC
        });

    }

    changeInci = (event) => {
        this.setState({ comment: event.label });
    }

    toggleModalClose = () => {

        this.setState({
            isActiveC: false
        })
    }

    showPosition = (position) => {
        let { coords } = position;
        let coordE = { lat: coords.latitude, lng: coords.longitude };

        this.setState({ coordE });
    }

    finishViaje = () => {
        let { carretera, kmFinal, comment } = this.state;
        let { userActu, coords, userViaj } = this.props;
        
        firebase.database().ref().child('SyncApps').orderByChild('programacionDia').equalTo(userActu.viajeAsignado)
            .once('value').then(snap => {
                snap.forEach(element => {
                    firebase.database().ref().child('SyncApps/' + element.key).remove();
                })

                firebase.database().ref().child('Vehiculos/' + userViaj.vehiculo).update({
                    estado: 'Disponible',
                    viajeAsignado: false
                }, () => {
                    firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).child('checkpoints').once('value').then(snap => {
                        if (snap.val() === null)
                            firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).child('checkpoints').set([{
                                timestamp: firebase.database.ServerValue.TIMESTAMP,
                                coordenadas: coords
                            }]);
                        else firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).child('checkpoints').set([
                            ...snap.val(), {
                                timestamp: firebase.database.ServerValue.TIMESTAMP,
                                coordenadas: coords
                            }]);
                    })
                    
                    firebase.database().ref().child('ProgramacionDia/' + userActu.viajeAsignado).update({
                        coordenadas: coords,
                        comentario: comment,
                        estado: 'Finalizado',
                        finalizo: firebase.database.ServerValue.TIMESTAMP,
                        carretera,
                        kmFinal
                    }, () => {
                        setTimeout(() => {
                            firebase.database().ref().child('Empleados/' + userActu.uid).update({
                                espera: false,
                                viajeAsignado: false
                            })
                        }, 1000);
                    });
                })
            })
    }


    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    handleKeyPressNumeros(e) {
        let tecla = e.which;
        let patron = /^[0-9]+$/;
        let tecla_final = String.fromCharCode(tecla);
        let rs = patron.test(tecla_final);
        if (!rs) { e.preventDefault(); }
    }

    changeCarre = (event) => {
        this.setState({ carretera: event.value })
    }

    render() {
        let { carreteras, isPoint, donee } = this.props;
        let { rapidin } = this.state;

        return (
            <div className='fondoB d-flex justify-content-end' >
                {/* {<div className='itemA'></div>
                 <div className='itemB'></div>} */}
                {isPoint && !donee &&
                    <div className='itemC'>
                        <img onClick={this.toggleModalC} className='imgR' src={check} alt="menu" />
                        <Modal key={'modalC'} isOpen={this.state.isActiveC} onRequestClose={() => this.toggleModalC()} style={customStyles}>
                            <div className="form-group">
                                <div className="modal">
                                    <div>
                                        <img className='imgc checkpoint' src={checkicon} alt="checkpoint" />
                                    </div>
                                    <div>
                                        <label>Checkpoint confirmado</label>
                                    </div>
                                </div>
                            </div>
                            <div className="aceptar">
                                <button onClick={this.toggleModalC} className="btn btn-green" >Aceptar</button>
                            </div>
                        </Modal>
                    </div>
                }
                <div className='itemD'>
                    <img onClick={() => this.toggleModalG('I')} className='imgR' src={finalizar} alt="menu" />
                    <Modal key={'modalI'} isOpen={this.state['isActiveI']} 
                    onRequestClose={() => this.setState({ isActiveI: false })} 
                    style={customStyles}>
                        <div className="form-group">
                            <label>Ingrese Comentario</label>
                            <textarea name="comment" className="form-control" value={this.state.comment} onChange={this.handleInputChange} placeholder="Comentario" />
                        </div>
                        <div className="form-check" style={{ marginBottom: 10 }}>
                            {/* <input className="form-check-input" type="checkbox" value={rapidin} onChange={this.handleInputChange} id="defaultCheck1" name="rapidin"/> */}
                            <input name="rapidin" className="form-check-input" type="checkbox" checked={rapidin} onChange={this.handleInputChange} />
                            <label className="form-check-label" for="defaultCheck1">
                                Comentario Rápido
                            </label>
                            <br></br>
                        </div>
                        {rapidin &&
                            <div className="form-group row">
                                <label className="col-sm-12 col-md-3 col-form-label">Incidencias</label>
                                <div className="col-sm-12 col-md-9">
                                    <Select onChange={this.changeInci} options={incidencias} />
                                </div>
                            </div>
                        }
                        <div className="form-group">
                            <label htmlFor="nombre">Kilometraje final</label>
                            <input type="text" name="kmFinal" className="form-control" onChange={this.handleInputChange}
                                placeholder="kM Final" autoComplete="off" onKeyPress={this.handleKeyPressNumeros} />
                        </div>
                        <div className="form-group row">
                            <label className="col-sm-12 col-md-4 col-form-label">Carretera</label>
                            <div className="col-sm-12 col-md-7">
                                <Select onChange={this.changeCarre} options={carreteras} />
                            </div>
                        </div>
                        <button onClick={() => this.finishViaje()} className="btn btn-green float-right">Aceptar</button>
                    </Modal>
                </div>
            </div>
        )
    }
}
export default withRouter(BarraButtom);


// WEBPACK FOOTER //
// ./src/Components/perfilEmpleado/BaraButtom.js